/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { XmlaSubscriptionTypeEx } from "../models/xmla-subscription-type-ex";
import { XmlaSubscriptionType } from "../models/xmla-subscription-type";
import { XmlaSubscriptionLevelEx } from "../models/xmla-subscription-level-ex";
import { XmlaSubscriptionPriceEx } from "../models/xmla-subscription-price-ex";
@Injectable({
  providedIn: "root",
})
class AdminXmlaSubscriptionService extends __BaseService {
  static readonly adminXmlaSubscriptionGetXmlaSubscriptionTypesPath =
    "/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionTypes";
  static readonly adminXmlaSubscriptionCreateXmlaSubscriptionTypePath =
    "/api/admin/xmla/AdminXmlaSubscription/CreateXmlaSubscriptionType";
  static readonly adminXmlaSubscriptionEditXmlaSubscriptionTypePath =
    "/api/admin/xmla/AdminXmlaSubscription/EditXmlaSubscriptionType";
  static readonly adminXmlaSubscriptionDeleteXmlaSubscriptionTypePath =
    "/api/admin/xmla/AdminXmlaSubscription/DeleteXmlaSubscriptionType";
  static readonly adminXmlaSubscriptionGetXmlaSubscriptionLevelsAllPath =
    "/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionLevelsAll";
  static readonly adminXmlaSubscriptionGetXmlaSubscriptionLevelsPath =
    "/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionLevels";
  static readonly adminXmlaSubscriptionCreateXmlaSubscriptionLevelPath =
    "/api/admin/xmla/AdminXmlaSubscription/CreateXmlaSubscriptionLevel";
  static readonly adminXmlaSubscriptionEditSubscriptionLevelPath =
    "/api/admin/xmla/AdminXmlaSubscription/EditXmlaSubscriptionLevel";
  static readonly adminXmlaSubscriptionDeleteXmlaSubscriptionLevelPath =
    "/api/admin/xmla/AdminXmlaSubscription/DeleteXmlaSubscriptionLevel";
  static readonly adminXmlaSubscriptionGetXmlaSubscriptionPricesPath =
    "/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionPrices";
  static readonly adminXmlaSubscriptionCreateSubscriptionPricePath =
    "/api/admin/xmla/AdminXmlaSubscription/CreateXmlaSubscriptionPrice";
  static readonly adminXmlaSubscriptionEditSubscriptionPricePath =
    "/api/admin/xmla/AdminXmlaSubscription/EditXmlaSubscriptionPrice";
  static readonly adminXmlaSubscriptionDeleteSubscriptionPricePath =
    "/api/admin/xmla/AdminXmlaSubscription/DeleteXmlaSubscriptionPrice";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminXmlaSubscriptionGetXmlaSubscriptionTypesResponse(): __Observable<
    __StrictHttpResponse<Array<XmlaSubscriptionTypeEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<XmlaSubscriptionTypeEx>>;
      })
    );
  }
  adminXmlaSubscriptionGetXmlaSubscriptionTypes(): __Observable<
    Array<XmlaSubscriptionTypeEx>
  > {
    return this.adminXmlaSubscriptionGetXmlaSubscriptionTypesResponse().pipe(
      __map((_r) => _r.body as Array<XmlaSubscriptionTypeEx>)
    );
  }

  /**
   * @param model undefined
   */
  adminXmlaSubscriptionCreateXmlaSubscriptionTypeResponse(
    model: XmlaSubscriptionType
  ): __Observable<__StrictHttpResponse<XmlaSubscriptionType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/CreateXmlaSubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<XmlaSubscriptionType>;
      })
    );
  }
  /**
   * @param model undefined
   */
  adminXmlaSubscriptionCreateXmlaSubscriptionType(
    model: XmlaSubscriptionType
  ): __Observable<XmlaSubscriptionType> {
    return this.adminXmlaSubscriptionCreateXmlaSubscriptionTypeResponse(
      model
    ).pipe(__map((_r) => _r.body as XmlaSubscriptionType));
  }

  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditXmlaSubscriptionTypeParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `subTypeId`:
   */
  adminXmlaSubscriptionEditXmlaSubscriptionTypeResponse(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditXmlaSubscriptionTypeParams
  ): __Observable<__StrictHttpResponse<XmlaSubscriptionType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/EditXmlaSubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<XmlaSubscriptionType>;
      })
    );
  }
  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditXmlaSubscriptionTypeParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `subTypeId`:
   */
  adminXmlaSubscriptionEditXmlaSubscriptionType(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditXmlaSubscriptionTypeParams
  ): __Observable<XmlaSubscriptionType> {
    return this.adminXmlaSubscriptionEditXmlaSubscriptionTypeResponse(
      params
    ).pipe(__map((_r) => _r.body as XmlaSubscriptionType));
  }

  /**
   * @param subTypeId undefined
   */
  adminXmlaSubscriptionDeleteXmlaSubscriptionTypeResponse(
    subTypeId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subTypeId != null)
      __params = __params.set("subTypeId", subTypeId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/DeleteXmlaSubscriptionType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param subTypeId undefined
   */
  adminXmlaSubscriptionDeleteXmlaSubscriptionType(
    subTypeId?: number
  ): __Observable<Blob> {
    return this.adminXmlaSubscriptionDeleteXmlaSubscriptionTypeResponse(
      subTypeId
    ).pipe(__map((_r) => _r.body as Blob));
  }
  adminXmlaSubscriptionGetXmlaSubscriptionLevelsAllResponse(): __Observable<
    __StrictHttpResponse<Array<XmlaSubscriptionLevelEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionLevelsAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<XmlaSubscriptionLevelEx>>;
      })
    );
  }
  adminXmlaSubscriptionGetXmlaSubscriptionLevelsAll(): __Observable<
    Array<XmlaSubscriptionLevelEx>
  > {
    return this.adminXmlaSubscriptionGetXmlaSubscriptionLevelsAllResponse().pipe(
      __map((_r) => _r.body as Array<XmlaSubscriptionLevelEx>)
    );
  }

  /**
   * @param xmlaSubscriptionTypeId undefined
   */
  adminXmlaSubscriptionGetXmlaSubscriptionLevelsResponse(
    xmlaSubscriptionTypeId?: number
  ): __Observable<__StrictHttpResponse<Array<XmlaSubscriptionLevelEx>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (xmlaSubscriptionTypeId != null)
      __params = __params.set(
        "xmlaSubscriptionTypeId",
        xmlaSubscriptionTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionLevels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<XmlaSubscriptionLevelEx>>;
      })
    );
  }
  /**
   * @param xmlaSubscriptionTypeId undefined
   */
  adminXmlaSubscriptionGetXmlaSubscriptionLevels(
    xmlaSubscriptionTypeId?: number
  ): __Observable<Array<XmlaSubscriptionLevelEx>> {
    return this.adminXmlaSubscriptionGetXmlaSubscriptionLevelsResponse(
      xmlaSubscriptionTypeId
    ).pipe(__map((_r) => _r.body as Array<XmlaSubscriptionLevelEx>));
  }

  /**
   * @param model undefined
   */
  adminXmlaSubscriptionCreateXmlaSubscriptionLevelResponse(
    model: XmlaSubscriptionLevelEx
  ): __Observable<__StrictHttpResponse<XmlaSubscriptionLevelEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/CreateXmlaSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<XmlaSubscriptionLevelEx>;
      })
    );
  }
  /**
   * @param model undefined
   */
  adminXmlaSubscriptionCreateXmlaSubscriptionLevel(
    model: XmlaSubscriptionLevelEx
  ): __Observable<XmlaSubscriptionLevelEx> {
    return this.adminXmlaSubscriptionCreateXmlaSubscriptionLevelResponse(
      model
    ).pipe(__map((_r) => _r.body as XmlaSubscriptionLevelEx));
  }

  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionLevelParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   */
  adminXmlaSubscriptionEditSubscriptionLevelResponse(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionLevelParams
  ): __Observable<__StrictHttpResponse<XmlaSubscriptionLevelEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.subLevelId != null)
      __params = __params.set("subLevelId", params.subLevelId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/EditXmlaSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<XmlaSubscriptionLevelEx>;
      })
    );
  }
  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionLevelParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   */
  adminXmlaSubscriptionEditSubscriptionLevel(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionLevelParams
  ): __Observable<XmlaSubscriptionLevelEx> {
    return this.adminXmlaSubscriptionEditSubscriptionLevelResponse(params).pipe(
      __map((_r) => _r.body as XmlaSubscriptionLevelEx)
    );
  }

  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteXmlaSubscriptionLevelParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   */
  adminXmlaSubscriptionDeleteXmlaSubscriptionLevelResponse(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteXmlaSubscriptionLevelParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.subLevelId != null)
      __params = __params.set("subLevelId", params.subLevelId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/DeleteXmlaSubscriptionLevel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteXmlaSubscriptionLevelParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   */
  adminXmlaSubscriptionDeleteXmlaSubscriptionLevel(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteXmlaSubscriptionLevelParams
  ): __Observable<Blob> {
    return this.adminXmlaSubscriptionDeleteXmlaSubscriptionLevelResponse(
      params
    ).pipe(__map((_r) => _r.body as Blob));
  }
  adminXmlaSubscriptionGetXmlaSubscriptionPricesResponse(): __Observable<
    __StrictHttpResponse<Array<XmlaSubscriptionPriceEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/GetXmlaSubscriptionPrices`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<XmlaSubscriptionPriceEx>>;
      })
    );
  }
  adminXmlaSubscriptionGetXmlaSubscriptionPrices(): __Observable<
    Array<XmlaSubscriptionPriceEx>
  > {
    return this.adminXmlaSubscriptionGetXmlaSubscriptionPricesResponse().pipe(
      __map((_r) => _r.body as Array<XmlaSubscriptionPriceEx>)
    );
  }

  /**
   * @param model undefined
   */
  adminXmlaSubscriptionCreateSubscriptionPriceResponse(
    model: XmlaSubscriptionPriceEx
  ): __Observable<__StrictHttpResponse<XmlaSubscriptionPriceEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/CreateXmlaSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<XmlaSubscriptionPriceEx>;
      })
    );
  }
  /**
   * @param model undefined
   */
  adminXmlaSubscriptionCreateSubscriptionPrice(
    model: XmlaSubscriptionPriceEx
  ): __Observable<XmlaSubscriptionPriceEx> {
    return this.adminXmlaSubscriptionCreateSubscriptionPriceResponse(
      model
    ).pipe(__map((_r) => _r.body as XmlaSubscriptionPriceEx));
  }

  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionPriceParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   *
   * - `periodId`:
   */
  adminXmlaSubscriptionEditSubscriptionPriceResponse(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<XmlaSubscriptionPriceEx>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.subLevelId != null)
      __params = __params.set("subLevelId", params.subLevelId.toString());
    if (params.periodId != null)
      __params = __params.set("periodId", params.periodId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/EditXmlaSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<XmlaSubscriptionPriceEx>;
      })
    );
  }
  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionPriceParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   *
   * - `periodId`:
   */
  adminXmlaSubscriptionEditSubscriptionPrice(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionEditSubscriptionPriceParams
  ): __Observable<XmlaSubscriptionPriceEx> {
    return this.adminXmlaSubscriptionEditSubscriptionPriceResponse(params).pipe(
      __map((_r) => _r.body as XmlaSubscriptionPriceEx)
    );
  }

  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteSubscriptionPriceParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   *
   * - `periodId`:
   */
  adminXmlaSubscriptionDeleteSubscriptionPriceResponse(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteSubscriptionPriceParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTypeId != null)
      __params = __params.set("subTypeId", params.subTypeId.toString());
    if (params.subLevelId != null)
      __params = __params.set("subLevelId", params.subLevelId.toString());
    if (params.periodId != null)
      __params = __params.set("periodId", params.periodId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/admin/xmla/AdminXmlaSubscription/DeleteXmlaSubscriptionPrice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteSubscriptionPriceParams` containing the following parameters:
   *
   * - `subTypeId`:
   *
   * - `subLevelId`:
   *
   * - `periodId`:
   */
  adminXmlaSubscriptionDeleteSubscriptionPrice(
    params: AdminXmlaSubscriptionService.AdminXmlaSubscriptionDeleteSubscriptionPriceParams
  ): __Observable<Blob> {
    return this.adminXmlaSubscriptionDeleteSubscriptionPriceResponse(
      params
    ).pipe(__map((_r) => _r.body as Blob));
  }
}

module AdminXmlaSubscriptionService {
  /**
   * Parameters for AdminXmlaSubscriptionEditXmlaSubscriptionType
   */
  export interface AdminXmlaSubscriptionEditXmlaSubscriptionTypeParams {
    model: XmlaSubscriptionType;
    subTypeId?: number;
  }

  /**
   * Parameters for AdminXmlaSubscriptionEditSubscriptionLevel
   */
  export interface AdminXmlaSubscriptionEditSubscriptionLevelParams {
    model: XmlaSubscriptionLevelEx;
    subTypeId?: number;
    subLevelId?: number;
  }

  /**
   * Parameters for AdminXmlaSubscriptionDeleteXmlaSubscriptionLevel
   */
  export interface AdminXmlaSubscriptionDeleteXmlaSubscriptionLevelParams {
    subTypeId?: number;
    subLevelId?: number;
  }

  /**
   * Parameters for AdminXmlaSubscriptionEditSubscriptionPrice
   */
  export interface AdminXmlaSubscriptionEditSubscriptionPriceParams {
    model: XmlaSubscriptionPriceEx;
    subTypeId?: number;
    subLevelId?: number;
    periodId?: number;
  }

  /**
   * Parameters for AdminXmlaSubscriptionDeleteSubscriptionPrice
   */
  export interface AdminXmlaSubscriptionDeleteSubscriptionPriceParams {
    subTypeId?: number;
    subLevelId?: number;
    periodId?: number;
  }
}

export { AdminXmlaSubscriptionService };
